(() => {
  'use strict';
  const isBoldQuestion = node => {
    const text = node.textContent.trim();
    if (!text || !/[?？]$/.test(text) || node.closest('details,script,style')) return false;
    // A formatted inline question can be inside arbitrary Shopify editor wrappers
    // and can share its paragraph with the answer after a line break.
    if (node.querySelector('p,div,li,table,h1,h2,h3,h4,h5,h6')) return false;
    return /^(STRONG|B)$/.test(node.tagName) || Number.parseInt(getComputedStyle(node).fontWeight, 10) >= 600;
  };
  const icon = () => {
    const node = document.createElement('span');
    node.className = 'faq-toggle-icon'; node.setAttribute('aria-hidden', 'true');
    return node;
  };
  const cleanEdges = fragment => {
    // Strip empty rich-text wrappers and leading line breaks copied at a boundary.
    const empty = node => node.nodeType === Node.TEXT_NODE ? !node.textContent.trim() :
      node.nodeType === Node.ELEMENT_NODE && (node.tagName === 'BR' ||
        (!node.textContent.trim() && !node.querySelector('img,video,iframe,svg,hr,input')));
    while (fragment.firstChild && empty(fragment.firstChild)) fragment.firstChild.remove();
    while (fragment.lastChild && empty(fragment.lastChild)) fragment.lastChild.remove();
    for (const edge of ['first','last']) {
      let parent = fragment;
      while (parent) {
        let child = edge === 'first' ? parent.firstChild : parent.lastChild;
        while (child && empty(child)) {
          child.remove(); child = edge === 'first' ? parent.firstChild : parent.lastChild;
        }
        parent = child?.nodeType === Node.ELEMENT_NODE ? child : null;
      }
    }
    return fragment;
  };
  function init(root) {
    if (root.dataset.faqInitialized) return;
    root.dataset.faqInitialized = 'true';
    root.querySelectorAll('details').forEach(item => {
      const summary = item.querySelector(':scope > summary');
      if (!summary) return;
      item.classList.add('faq-item');
      if (!summary.querySelector('.faq-toggle-icon')) summary.append(icon());
    });
    const candidates = [...root.querySelectorAll('strong,b,h2,h3,h4,h5,h6,[style]')].filter(isBoldQuestion);
    const questions = candidates.filter(node => !candidates.some(other => other !== node && other.contains(node)));
    if (!questions.length) return;
    // Category headings and existing accordions are independent boundaries, so
    // their titles do not become part of the preceding answer.
    const categories = [...root.querySelectorAll('h1,h2,h3,h4,h5,h6,details')].filter(node =>
      !questions.some(q => q === node || q.contains(node) || node.contains(q)) &&
      !node.parentElement.closest('details'));
    const markers = [...questions.map(node => ({node,question:true})), ...categories.map(node => ({node,question:false}))]
      .sort((a,b) => a.node.compareDocumentPosition(b.node) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
    const output = document.createDocumentFragment();
    let start = {node:root,offset:0};
    let answer = null;
    const appendUntil = end => {
      const range = document.createRange(); range.setStart(start.node,start.offset); range.setEndBefore(end);
      const fragment = cleanEdges(range.cloneContents());
      (answer || output).append(fragment);
    };
    markers.forEach(marker => {
      appendUntil(marker.node);
      output.append(document.createTextNode('\n'));
      if (marker.question) {
        const details = document.createElement('details'); details.className = 'faq-item';
        const summary = document.createElement('summary');
        const title = document.createElement('span'); title.textContent = marker.node.textContent.trim();
        summary.append(title,icon());
        answer = document.createElement('div'); answer.className = 'faq-answer rte';
        details.append(summary,answer); output.append(details);
      } else {
        const copy = marker.node.cloneNode(true);
        if (/^H[1-6]$/.test(copy.tagName)) copy.classList.add('faq-category');
        output.append(copy); answer = null;
      }
      const parent = marker.node.parentNode;
      start = {node:parent,offset:[...parent.childNodes].indexOf(marker.node)+1};
    });
    const tail = document.createRange(); tail.setStart(start.node,start.offset); tail.setEnd(root,root.childNodes.length);
    (answer || output).append(cleanEdges(tail.cloneContents()));
    root.replaceChildren(output);
  }
  const scan = () => document.querySelectorAll('[data-faq-existing]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan);
  else scan();
  document.addEventListener('shopify:section:load',scan);
})();
